import React, { ReactNode, useEffect, useState } from "react";
import Keycloak from "keycloak-js";

interface KeycloakContextType {
    keycloak: Keycloak | null;
    initialized: boolean;
    authenticated: boolean;
}

export const KeycloakContext = React.createContext<KeycloakContextType>({
    keycloak: null,
    initialized: false,
    authenticated: false,
});

interface Props {
    children: ReactNode;
}

// Aquí guardamos la instancia en window para que no se cree más de una en hot reload
declare global {
  interface Window {
    __KEYCLOAK_INSTANCE__?: Keycloak;
  }
}

const getKeycloakInstance = () => {
  if (!window.__KEYCLOAK_INSTANCE__) {
    window.__KEYCLOAK_INSTANCE__ = new Keycloak({
      url: import.meta.env.VITE_KEYCLOAK_URL,
      realm: import.meta.env.VITE_KEYCLOAK_REALM,
      clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    });
  }
  return window.__KEYCLOAK_INSTANCE__;
};

export const KeycloakProvider = ({ children }: Props) => {
    const [initialized, setInitialized] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);

    const keycloak = getKeycloakInstance();

    useEffect(() => {
        let refreshInterval: NodeJS.Timeout;

        keycloak
            .init({ onLoad: "login-required", checkLoginIframe: false })
            .then((auth) => {
                setInitialized(true);
                setAuthenticated(auth);

                if (auth) {
                    refreshInterval = setInterval(() => {
                        keycloak.updateToken(60).catch(() => {
                            keycloak.logout();
                        });
                    }, 60000);
                } else {
                    keycloak.login();
                }
            })
            .catch((error) => {
                console.error("Error inicializando Keycloak:", error);
            });

        return () => {
            if (refreshInterval) clearInterval(refreshInterval);
        };
    }, [keycloak]);

    return (
        <KeycloakContext.Provider value={{ keycloak, initialized, authenticated }}>
            {initialized ? children : <div>Loading...</div>}
        </KeycloakContext.Provider>
    );
};
